import React from 'react';
import type { DossierNextActionSection } from '../../../services/CrmDossierService';
import { agendaPath, formatDossierWhen } from './dossierFormat';

interface Props {
  section: DossierNextActionSection;
  onOpen: (path: string) => void;
  onRegister: () => void;
}

/** Próxima ação derivada de dados (sem IA). Indisponível não recomenda nada. */
const DossierNextAction: React.FC<Props> = ({ section, onOpen, onRegister }) => {
  const action = section.action;
  return (
    <section className="dossier-card dossier-next" data-testid="dossier-next-action">
      <h3 className="dossier-card__title">Próxima ação</h3>
      {section.status === 'unavailable' || !action ? (
        <p role="alert">Não deu para calcular a próxima ação agora.</p>
      ) : (
        <div className="dossier-next__body">
          <div className="dossier-next__tags">
            {action.scope === 'contact' && <span className="dossier-chip">Do cliente</span>}
            {action.byAi && <span className="dossier-chip dossier-chip--ai">A IA executa</span>}
          </div>
          <strong className="dossier-next__title">{action.title}</strong>
          {action.detail && <p className="dossier-next__detail">{action.detail}</p>}
          {action.at && <span className="dossier-item__meta">{formatDossierWhen(action.at)}</span>}
          {action.evidenceQuote && <span className="dossier-item__quote">{`“${action.evidenceQuote}”`}</span>}
          <div className="dossier-item__actions">
            {action.kind === 'none' ? (
              <button type="button" className="dossier-btn dossier-btn--primary" onClick={onRegister}>
                Registrar
              </button>
            ) : (
              action.openPath && (
                <button type="button" className="dossier-btn dossier-btn--primary" onClick={() => onOpen(agendaPath(action.openPath as string, action.at))}>
                  Abrir
                </button>
              )
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default DossierNextAction;
